module.exports = __webpack_public_path__ + "static/media/Github.08225912.svg";